export interface TCallToAction {
  id: number;
  eventId: number;
  roomId: number;
  text: string;
  nameBtn: string;
  nameImg: string;
  urlBtn: string;
  urlImg: string;
  colorBtn: string;
  typeBtn: number;
  positionBtn: number;
  countClicks: number;
  clicksUsers: { id2: string }[] | null;
  timeout: number;
}

export interface TDataCallToAction {
  event_id: number;
  roomId: number;
  callActionId: number;
}

export interface TCallToActionState {
  data: TCallToAction | null;
  error: string | null;
  loading: boolean;
}

enum ActionTypes {
  SET_CALL_TO_ACTION = 'SET_CALL_TO_ACTION',

  GET_CALL_TO_ACTION_R = 'GET_CALL_TO_ACTION_R',
  GET_CALL_TO_ACTION_S = 'GET_CALL_TO_ACTION_S',
  GET_CALL_TO_ACTION_E = 'GET_CALL_TO_ACTION_E',

  CLICK_CALL_TO_ACTION_R = 'CLICK_CALL_TO_ACTION_R',
  CLICK_CALL_TO_ACTION_S = 'CLICK_CALL_TO_ACTION_S',
  CLICK_CALL_TO_ACTION_E = 'CLICK_CALL_TO_ACTION_E',
}

export default ActionTypes;
